import { render, staticRenderFns } from "./m-plank-filter.vue?vue&type=template&id=2b7206d1&"
import script from "./m-plank-filter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-plank-filter.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-plank-filter.vue?vue&type=style&index=0&id=2b7206d1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports